import React, { useState, useEffect } from "react";
import { Button, Card, Col, Modal, Row, Spinner } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { checkIfOnline } from "../../utils";
import { useSelector } from "react-redux";
import moment from "moment-timezone";
import { getAssesmentById } from "../../services/AssesmentService";
import { useParams } from "react-router-dom";

import $ from "jquery";
import logo from "../../images/logo/akdn.png";

const { d3 } = window;

function Assesment5Summary(props) {
  const { history } = props;
  const [selection, setSelection] = useState("Recruitment");
  const [downloadingPDF, setDownloadingPDF] = React.useState(false);
  const [downloadingPDFImage, setDownloadingPDFImage] = React.useState(false);

  const [assesment, setAssesment] = React.useState(undefined);
  const [assesmentResponse, setAssesmentResponse] = React.useState(undefined);
  const user = useSelector((state) => state.auth.auth);
  const [loaded, setLoaded] = useState(false);
  const { assesmentId } = useParams();
  const [assesmentDetails, setAssesmentDetails] = React.useState({
    assesorFirstName: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    assesorPhoneNumber: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    assesorEmail: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    supervisor: [],
    coAssessortFirstName: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    coAssesorPhoneNumber: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    coAssesorEmail: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    nationalCouncil: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    siteName: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    city: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    country: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    address: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    longitude: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    latitude: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
    date: {
      value: "",
      comment: "",
      image: "",
      isNA: {
        flag: false,
        value: "",
        comment: "",
      },
    },
  });
  const [radarResponse, setRadarResponse] = useState({
    dutyOfInformation: {
      recruitment: 0,
      induction_and_onboarding: 0,
      training: 0,
      risk_assessment: 0,
      pre_departure_for_traveller: 0,
    },
    duty_of_prevention: {
      risk_treatment: 0,
      pre_departure_measure: 0,
      insuring_against_risk: 0,
    },
    duty_of_monitoring: {
      auditing: 0,
      safety_and_security: 0,
      documentation: 0,
    },
    duty_of_intervention: {
      crisis_management: 0,
      post_deployment: 0,
      complaints_mechanism: 0,
      disciplinary_procedures: 0,
      health_and_safety: 0,
      redress_measure: 0,
      risk_management: 0,
      partnership_arrangement: 0,
    },
  });

  let data = [
    [
      { axis: "Recruitment", value: 1 },
      { axis: "Induction / Onboarding", value: 1 },
      { axis: "Training", value: 1 },
      { axis: "Risk Assessment", value: 1 },
      { axis: "Pre-departure Briefings", value: 1 },
      { axis: "Risk Treatment", value: 1 },
      { axis: "Pre-departure Measures", value: 1 },
      { axis: "Insuring Against Risks", value: 1 },
      { axis: "Auditing", value: 1 },
      { axis: "Information Management", value: 1 },
      { axis: "Documentation", value: 1 },
      { axis: "Crisis Management", value: 1 },
      { axis: "Travel De-briefings", value: 1 },
      { axis: "Complaints Mechanism", value: 1 },
      { axis: "Disciplinary Procedures", value: 1 },
      { axis: "Health And Safety", value: 1 },
      { axis: "Redress Measures", value: 1 },
      { axis: "Risk Management", value: 1 },
      { axis: "Partnership Arrangements", value: 1 },
    ],
  ];
  const updateRaderChart = () => {
    data = [
      [
        {
          axis: "Recruitment",
          value: radarResponse.dutyOfInformation.recruitment,
        },
        {
          axis: "Induction / Onboarding",
          value: radarResponse.dutyOfInformation.induction_and_onboarding,
        },
        { axis: "Training", value: radarResponse.dutyOfInformation.training },
        {
          axis: "Risk Assessment",
          value: radarResponse.dutyOfInformation.risk_assessment,
        },
        {
          axis: "Pre-departure Briefings",
          value: radarResponse.dutyOfInformation.pre_departure_for_traveller,
        },
        {
          axis: "Risk Treatment",
          value: radarResponse.duty_of_prevention.risk_treatment,
        },
        {
          axis: "Pre-departure Measures",
          value: radarResponse.duty_of_prevention.pre_departure_measure,
        },
        {
          axis: "Insuring Against Risks",
          value: radarResponse.duty_of_prevention.insuring_against_risk,
        },
        { axis: "Auditing", value: radarResponse.duty_of_monitoring.auditing },
        {
          axis: "Information Management",
          value: radarResponse.duty_of_monitoring.safety_and_security,
        },
        {
          axis: "Documentation",
          value: radarResponse.duty_of_monitoring.documentation,
        },
        {
          axis: "Crisis Management",
          value: radarResponse.duty_of_intervention.crisis_management,
        },
        {
          axis: "Travel De-briefings",
          value: radarResponse.duty_of_intervention.post_deployment,
        },
        {
          axis: "Complaints Mechanism",
          value: radarResponse.duty_of_intervention.complaints_mechanism,
        },
        {
          axis: "Disciplinary Procedures",
          value: radarResponse.duty_of_intervention.disciplinary_procedures,
        },
        {
          axis: "Health And Safety",
          value: radarResponse.duty_of_intervention.health_and_safety,
        },
        {
          axis: "Redress Measures",
          value: radarResponse.duty_of_intervention.redress_measure,
        },
        {
          axis: "Risk Management",
          value: radarResponse.duty_of_intervention.risk_management,
        },
        {
          axis: "Partnership Arrangements",
          value: radarResponse.duty_of_intervention.partnership_arrangement,
        },
      ],
    ];

    RadarChart();
  };

  const getText = (value) => {
    let text = "";
    switch (value) {
      case 0:
        text = "Initial";
        break;
      case 1:
        text = "Structured";
        break;
      case 2:
        text = "Defined";
        break;
      case 3:
        text = "Measured";
        break;
      case 4:
        text = "Optimised";
        break;
      default:
        text = "Optimised";
    }
    return text;
  };

  let chartVars = {};

  function RadarChart() {
    const _this = chartVars;

    const setDesktopVar = () => {
      _this.margin = { top: 180, right: 180, bottom: 120, left: 180 };
      _this.w = Math.max(
        360,
        Math.min(800, window.innerWidth - 10) -
          _this.margin.left -
          _this.margin.right
      );
      _this.h = Math.max(
        360,
        Math.min(
          _this.w,
          window.innerHeight - _this.margin.top - _this.margin.bottom - 20
        )
      );
      _this.dotRadius = 5;
      _this.wrapWidth = 90;
      _this.minRadius = 40;
      _this.maxRadius = Math.min(_this.w / 2, _this.h / 2);
      _this.labelFactor = 1.333;
      _this.rScale = d3.scale
        .linear()
        .range([_this.minRadius, _this.maxRadius])
        .domain([0, _this.maxValue]);
    };

    const init = () => {
      _this.timer = 0;
      _this.highlight = 0;
      _this.maxValue = 4;
      _this.levels = 4;
      _this.blobColor = ["#BB0099"];
      _this.dutyColor = [
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "none",
        "#CCCC22",
        "#CCCC22",
        "#CCCC22",
        "#CCCC22",
        "#CCCC22",
        "#CCCC22",
        "#CCCC22",
        "#CCCC22",
        "none",
        "#FFA000",
        "#FFA000",
        "#FFA000",
        "#FFA000",
        "#FFA000",
        "#FFA000",
        "#FFA000",
        "#FFA000",
        "none",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "none",
      ];
      _this.topicColor = [
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#66CCFF",
        "#CCCC22",
        "#CCCC22",
        "#CCCC22",
        "#FFA000",
        "#FFA000",
        "#FFA000",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
        "#AA5500",
      ];
      _this.opacityBlob = 0.5;
      _this.strokeWidthBlob = 0;
      _this.opacityScoreCircles = 0.4;
      _this.maxValue = Math.max(
        4,
        d3.max(data, function (r) {
          return d3.max(
            r.map(function (r) {
              return r.value;
            })
          );
        })
      );
      _this.allAxis = data[0].map(function (r, e) {
        return r.axis;
      });
      _this.total = _this.allAxis.length;
      _this.angleSlice = (2 * Math.PI) / _this.total;
      _this.arcSlices = 3;
      _this.aScale = d3.scale
        .linear()
        .range([0, 2 * Math.PI])
        .domain([0, data[0].length * _this.arcSlices]);
      setDesktopVar();

      $("#page").fadeIn(100);
      // blob();
    };

    const blob = () => {
      _this.radarLine = d3.svg.line
        .radial()
        .tension(0.66)
        .radius(function (r) {
          return _this.rScale(r.value);
        })
        .angle(function (r, e) {
          return e * _this.angleSlice;
        });

      _this.blobWrapper = _this.g
        .selectAll(".blobWrapper")
        .data(data)
        .enter()
        .append("g")
        .attr("class", "blobWrapper")
        .attr("transform", "rotate(0)");

      _this.blobWrapper
        .append("path")
        .attr("id", "blob")
        .attr("d", function (r, e) {
          return _this.radarLine(r);
        })
        .style("fill", function (r, e) {
          return _this.blobColor[e];
        })
        .style("fill-opacity", _this.opacityBlob);

      _this.blobWrapper.select("#blob");

      _this.closestPoint = function (r, e) {
        function n(r) {
          const n = r.x - e[0];
          const t = r.y - e[1];
          return n * n + t * t;
        }
        const t = r.getTotalLength();
        const a = [];
        const i = 4;
        let o;
        let c;
        let s = 1 / 0;
        let u;
        for (let l = 0; l <= 4; l++) {
          a.push(r.getPointAtLength((t / 4) * l));
          (o = n(a[l])) < s && ((s = o), (c = a[l]), (u = l));
        }
        return ((c = [c.x, c.y]).distance = Math.sqrt(s)), (c.level = u), c;
      };

      _this.dragged = function (r, i) {
        var { x } = d3.event;
        var { y } = d3.event;

        const e = [x, y];
        const n = $(this).attr("data-axis");
        const t = d3.select(`#axis${n}`);
        const a = _this.closestPoint(t.node(), e);

        d3.select(this).attr("cx", a[0]);
        d3.select(this).attr("cy", a[1]);

        var x = a[0];
        var y = a[1];

        let value = Math.max(
          0,
          Math.min(
            _this.maxValue,
            _this.rScale.invert(Math.sqrt(x * x + y * y))
          )
        );
        value = Math.round(value);

        r.value = value;
        const c = this.getBoundingClientRect();

        switch (value) {
          case 0:
            text = "Initial";
            break;
          case 0:
            text = "Structured";
            break;
          case 1:
            text = "Defined";
            break;
          case 2:
            text = "Measured";
            break;
          case 3:
            text = "Optimised";
            break;
          default:
            text = "";
        }

        for (var i = 0; i < data[0].length; i++)
          if (data[0][i].id == n) {
            data[0][i].value = value;
            break;
          }

        d3.select(this).classed("selected", true),
          _this.tooltip
            .text(text)
            .addClass("active")
            .offset({ top: c.y + 200, left: c.x + 20 });

        updateBlob(data);
      };

      _this.dragend = function (r) {
        d3.select(this).classed("selected", false);
        _this.tooltip.removeClass("active");
        //updateData(r);
      };

      _this.mouseover = function (d, i) {
        const t = this.getBoundingClientRect();

        const x = d3.select(this).attr("cx");
        const y = d3.select(this).attr("cy");

        const newX = t.x + 20;
        const newY = t.y + 20;

        let value = Math.max(
          0,
          Math.min(
            _this.maxValue,
            _this.rScale.invert(Math.sqrt(x * x + y * y))
          )
        );
        value = Math.round(value);

        switch (value) {
          case 0:
            text = "Initial";
            break;
          case 0:
            text = "Structured";
            break;
          case 1:
            text = "Defined";
            break;
          case 2:
            text = "Measured";
            break;
          case 3:
            text = "Optimised";
            break;
          default:
            text = "";
        }

        d3.select(this).classed("selected", true),
          _this.tooltip
            .text(text)
            .addClass("active")
            .offset({ top: newY + 200, left: newX });
      };

      _this.mouseout = function (r) {
        d3.select(this).classed("selected", false);
        _this.tooltip.removeClass("active");
      };

      _this.blobWrapper
        .selectAll(".blobCircle")
        .data(function (r, e) {
          return r;
        })
        .enter()
        .append("circle")
        .attr("class", "blobCircle")
        .attr("data-axis", function (r, e) {
          return e;
        })
        .attr("r", _this.dotRadius)
        .attr("cx", function (r, e) {
          return (
            _this.rScale(r.value) * Math.cos(_this.angleSlice * e - Math.PI / 2)
          );
        })
        .attr("cy", function (r, e) {
          return (
            _this.rScale(r.value) * Math.sin(_this.angleSlice * e - Math.PI / 2)
          );
        }),
        // _this.blobWrapper
        //   .selectAll('.blobCircle')
        //   .on('mouseover', _this.mouseover)
        //   .on('mouseout', _this.mouseout)
        //   .call(
        //     d3.behavior
        //       .drag()
        //       .on('drag', _this.dragged)
        //       .on('dragend', _this.dragend)
        //   );

        _this.tooltip || $("#radar").append("<div id='tooltip'></div>");
      _this.tooltip = $("#tooltip");
    };

    const updateBlob = (r) => {
      _this.blobWrapper.data(r),
        _this.blobWrapper
          .select("#blob")
          .transition()
          .attr("d", function (r, e) {
            return _this.radarLine(r);
          });
      _this.blobWrapper
        .selectAll(".blobCircle")
        .data(function (r, e) {
          return r;
        })
        .each(function (r, e) {
          d3.select(this)
            .transition()
            .attr("cx", function (r, n) {
              return (
                _this.rScale(r.value) *
                Math.cos(_this.angleSlice * e - Math.PI / 2)
              );
            })
            .attr("cy", function (r, n) {
              return (
                _this.rScale(r.value) *
                Math.sin(_this.angleSlice * e - Math.PI / 2)
              );
            });
        });
    };

    const wrap = (text, e) => {
      text.each(function (r, n, t) {
        for (
          var a = d3.select(this),
            i = r.split(/\s+/).reverse(),
            o,
            c = [],
            s = 0,
            u = 1.15,
            l = a.attr("y"),
            X = a.attr("x"),
            P = parseFloat(a.attr("dy")),
            d = a
              .text(null)
              .append("tspan")
              .attr("x", X)
              .attr("y", l)
              .attr("dy", `${P}em`);
          (o = i.pop());

        )
          c.push(o),
            d.text(c.join(" ")),
            d.node().getComputedTextLength() > e &&
              c.length > 1 &&
              (c.pop(),
              d.text(c.join(" ")),
              (c = [o]),
              (d = a
                .append("tspan")
                .attr("x", X)
                .attr("y", l)
                .attr("dy", `${++s * u + P}em`)
                .text(o)));
      });
    }; // wrap

    const chart = (id) => {
      d3.select(id).selectAll("svg").remove();

      _this.svg = d3
        .select(id)
        .append("svg")
        .attr("width", _this.w + _this.margin.left + _this.margin.right)
        .attr("height", _this.h + _this.margin.top + _this.margin.bottom)
        .attr("id", "radarChart");

      _this.g = _this.svg
        .append("g")
        .attr(
          "transform",
          `translate(${_this.w / 2 + _this.margin.left},${
            _this.h / 2 + _this.margin.top
          })`
        );

      _this.rotateWrapper = _this.g
        .append("g")
        .attr("class", "rotateWrapper")
        .attr("transform", "rotate(0)");

      _this.arcGrid = _this.rotateWrapper
        .append("circle")
        .attr("id", "rotateBack")
        .attr("r", function (r, e) {
          return _this.maxRadius;
        })
        .style("fill", "#e9e7d3")
        .style("stroke", "none");

      _this.arcGrid = _this.rotateWrapper
        .append("g")
        .attr("class", "arcWrapper");

      _this.arc = d3.svg
        .arc()
        .innerRadius(_this.minRadius)
        .outerRadius(_this.maxRadius)
        .startAngle(function (r, e) {
          return _this.aScale(r - 1);
        })
        .endAngle(function (r, e) {
          return _this.aScale(r);
        });

      _this.arcWrapper = _this.arcGrid
        .selectAll(".arc")
        .data(d3.range(0, data[0].length * _this.arcSlices))
        .enter()
        .append("path")
        .attr("class", "arc")
        .attr("d", function (r, e) {
          return _this.arc(r);
        })
        .style("fill", function (r, e) {
          return _this.dutyColor[e];
        })
        .style("fill-opacity", 1)
        .style("stroke-width", 0.3)
        .style("stroke", function (r, e) {
          return _this.dutyColor[e];
        });

      _this.levelGrid = _this.rotateWrapper
        .append("g")
        .attr("class", "levelWrapper");

      _this.levelWrapper = _this.levelGrid
        .selectAll(".level")
        .data(d3.range(0, _this.levels + 1).reverse())
        .enter()
        .append("circle")
        .attr("class", "level")
        .attr("r", function (r, e) {
          return (
            ((_this.maxRadius - _this.minRadius) / _this.levels) * r +
            _this.minRadius
          );
        })
        .style("fill", "#FFFFFF")
        .style("stroke", "none")
        .style("fill-opacity", _this.opacityScoreCircles);

      _this.axisGrid = _this.rotateWrapper
        .append("g")
        .attr("class", "axisWrapper");

      _this.axis = _this.axisGrid
        .selectAll(".axis")
        .data(_this.allAxis)
        .enter()
        .append("g")
        .attr("class", "axis");

      _this.axis
        .append("path")
        .attr("d", function (r, e) {
          let n;
          let t;
          let a;
          let i;
          return `M${
            _this.minRadius * Math.cos(_this.angleSlice * e - Math.PI / 2)
          } ${_this.minRadius * Math.sin(_this.angleSlice * e - Math.PI / 2)} L${_this.rScale(_this.maxValue) * Math.cos(_this.angleSlice * e - Math.PI / 2)} ${_this.rScale(_this.maxValue) * Math.sin(_this.angleSlice * e - Math.PI / 2)}`;
        })
        .attr("class", "line")
        .attr("id", function (r, e) {
          return `axis${e}`;
        })
        .style("stroke", function (r, e) {
          return _this.topicColor[e];
        })
        .style("stroke-width", "0.5px");

      _this.axis
        .append("text")
        .attr("class", "legend")
        .attr("text-anchor", "middle")
        .attr("dy", "0.35em")
        .attr("x", function (r, e) {
          return (
            _this.rScale(_this.maxValue * _this.labelFactor) *
            Math.cos(_this.angleSlice * e - Math.PI / 2)
          );
        })
        .attr("y", function (r, e) {
          return (
            _this.rScale(_this.maxValue * _this.labelFactor) *
            Math.sin(_this.angleSlice * e - Math.PI / 2)
          );
        })
        .text(function (r) {
          return r;
        })
        .call(wrap, _this.wrapWidth);
    };

    init();
    chart("#radar");
    blob();
  }

  React.useEffect(async () => {
    if (assesmentId && assesmentId !== "undefined") {
      const data = await getAssesmentById(assesmentId);
      if (data) {
        const parsedData = JSON.parse(data.assessmentResponse);
        setAssesment(data);
        setAssesmentResponse(parsedData);
        setAssesmentDetails(parsedData.assesmentDetails);
        setRadarResponse(parsedData.radarResponse);
      }
    } else if (assesmentId === "undefined") {
      const data = location.state.assesment;
      const parsedData = JSON.parse(data.assessmentResponse);
      data.assesmentUser = { name: user.displayName, email: user.email };
      setAssesment(data);
      setAssesmentResponse(parsedData);
      setAssesmentDetails(parsedData.assesmentDetails);
      setRadarResponse(parsedData.radarResponse);
    }
    setLoaded(true);
  }, [assesmentId]);

  const navigationOpenInNewTab = () => {
    window.open("https://dutyofcare.cinfo.ch/index.html", "_blank");
  };

  /**
   * Update chart data
   * according saved render responce
   */
  useEffect(() => {
    updateRaderChart();
  }, [radarResponse]);

  const exportPdf = () => {
    setDownloadingPDF(true);
    const input = document.getElementById("capture");
    const inputHeight = input.clientHeight;
    const inputWidth = input.clientWidth;

    const maxPageHeight = 10800;
    const maxPageWidth = inputWidth; // Use the width of the PDF page

    const scaleFactorHeight = Math.min(1, maxPageHeight / inputHeight);
    const scaleFactorWidth = Math.min(1, maxPageWidth / inputWidth);

    const scaleFactor = Math.min(scaleFactorHeight, scaleFactorWidth);

    const scaledWidth = inputWidth * scaleFactor;
    const scaledHeight = inputHeight * scaleFactor;

    const pdf = new jsPDF("p", "px", [scaledWidth, scaledHeight], true);
    const { width } = pdf.internal.pageSize;
    const { height } = pdf.internal.pageSize;

    const pages = scaledHeight / height;

    const pageNo = pages;
    const pageCount = pages < 1 ? 1 : Math.trunc(pageNo);

    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");

      for (let i = 1; i <= pageCount; i++) {
        const pdfStartingHeight = height * (i - 1);
        pdf.addImage(
          imgData,
          "PNG",
          0,
          -pdfStartingHeight,
          scaledWidth,
          scaledHeight,
          "",
          "FAST"
        );

        if (i < pageCount) {
          pdf.addPage();
        }
      }

      setDownloadingPDF(false);
      const fileName = `DOC Assessment-${
        JSON.parse(assesment.assessmentResponse)?.assesmentDetails?.siteName
          ?.value || ""
      }-${
        JSON.parse(assesment.assessmentResponse)?.assesmentDetails?.country
          ?.value ||
        JSON.parse(assesment.assessmentResponse)?.assesmentDetails?.country
          ?.value?.value ||
        ""
      }-${moment(assesment.assessmentDate).format("DD-MM-YYYY")}`;
      pdf.save(`${fileName}.pdf`);
    });
  };

  const exportImage = () => {
    setDownloadingPDFImage(true);
    const input = document.getElementById("capture");
    const inputHeight = input.clientHeight;
    const inputWidth = input.clientWidth;
    const pdf = new jsPDF("p", "px", [inputWidth, inputHeight]);
    const { width } = pdf.internal.pageSize;
    const { height } = pdf.internal.pageSize;
    const pageHeightInPixels = inputHeight;
    const pages = pageHeightInPixels / height;

    // const roundOff = Number(pages.toString().split('.')[1].substring(0, 1));
    const pageNo = pages;
    const pageCount = pages < 1 ? 1 : Math.trunc(pageNo);
    html2canvas(input).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = imgData;
      setDownloadingPDFImage(false);
      const fileName = `cinfo-${moment(assesment.assessmentDate).format(
        "DD-MM-YYYY"
      )}`;
      link.download = `${fileName}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const getRecuritmentText = (value) => {
    switch (value) {
      case 0:
        return "Security and safety information is fed into the recruitment of new staff members on an ad hoc or reactive basis.";
      case 1:
        return "Safety and security information feeds into recruitment based on the risk levels of locations and roles. Risk assessments for the context and candidate are carried out. Prospective candidates are provided with safety and security information relevant to the context and candidate.";
      case 2:
        return "Safety and security information and risk assessement are documented and systematically fed into the recruitment process based on risk levels for locations and roles. Consent on security is included in the employment contract. Security training needs are assessed and fed into training methods. This includes: – Carrying out a risk assessment before recruitment and again upon selection of a final candidate. – Providing security information to prospective candidates before recruitment. Security and safety input into the recruitment process can include, for example: – Information on personal risk profiles. – Security and safety information in the job description and recruitment advertisement. – Security and safety questions in the interview questionnaire";
      case 3:
        return "Recruitment is monitored in order to assess the level of security and safety information provided during recruitment. Non-compliance with documented requirements is managed in accordance with consistently-applied, transparent and documented disciplinary procedures.";
      case 4:
        return "Improvement is achieved through learnings from: – internal and external incidents – other organisational processes (e.g., risk assessments) – staff consultation (recruiters and recruited) – expert review – peer learning/community of practice Feedback from recruited staff is systematically obtained and fed back to recruitment.";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getInductionText = (value) => {
    switch (value) {
      case 0:
        return "Some form of induction received by most staff. This induction is more or less informal.";
      case 1:
        return "New staff receives essential information and documentation after recruitment and prior to deployment. This includes: – key policy documents related to duty of care – relevant procedures – code of conduct";
      case 2:
        return "A systematic and compulsory induction of new staff is part of the onboarding after starting their function / before deployment. As part of the induction staff receive specific briefings to ensure their understanding of: – key policies and/or regulations (e.g. Code of conduct, security, insurance, sexual harassment, mobbing, whistleblowing) – related procedures including local security plans – roles and responsibilities concerning duty of care as required – other key briefings related to the role The nature and content of the briefings are defined in accordance with the work country‘s risk level.";
      case 3:
        return "Induction is documented through: – Attendance of staff to their induction briefings. – The provision of key documents. – Roles and responsibilities are communicated and clarified. Non-compliance with documented requirements is managed in accordance with consistentlyapplied, transparent and documented disciplinary procedures.";
      case 4:
        return "Improvement is achieved through learnings from: – internal and external incidents – risk assessment – staff consultation (recruiters and recruited) – expert review – peer learning/community of practice Feedback from staffs‘ induction is systematically obtained and fed back to the induction process.";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getTrainingText = (value) => {
    switch (value) {
      case 0:
        return "There are some opportunities for staff to develop their personal capacity based on their interests in relation to their job";
      case 1:
        return "Training options are available to staff pertaining to: – personal safety and security – their role as managers (SSRM and crisis management) Key competencies relating to duty of care are identified in organisational documentation.";
      case 2:
        return "Staff are required to complete training as per identified needs, carried out by experts on key competencies in relation to: – personal safety and security – their role as managers (SSRM and crisis management) – organisation-specific safety and security plans and procedures The process ensures that training needs are assessed and satisfied based on: – staff members‘ personal risk profile – the work country‘s risk level";
      case 3:
        return "Personal staff development is documented and failure to obtain identified key competencies within a specified period is recorded, and redress measures are taken.";
      case 4:
        return "Feedback on training is regulary obtained from: – trainers – trainees – experts – peers/community of practice This information is used to inform policy and future training. Identified key competencies relating to duty of care are regularly re-assessed and adapted to changing risks.";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getRiskAssessmentText = (value) => {
    switch (value) {
      case 0:
        return "Safety and security risk assessments are carried out in a reactive or ad hoc manner without a standardised template and used only at local level.";
      case 1:
        return "There are policies and plans in place, which regulate safety and security risk assessements and associated responsibilities are clarified in job descriptions. There is a defined template for risk assessments.";
      case 2:
        return "Safety and security risk assessment is regularly updated according to a context-specific frequency. The risk assessment includes the following outputs: – understanding of threats and hazards (including physical and psychological ones) – the vulnerability of staff/assets to these threats and hazards – risk level categorisation of locations and activities Findings from risk assessments are systematically integrated into other management processes beyond security management, e.g. project cycle management, country strategy development, acquisition";
      case 3:
        return "Safety and security risk assessment otputs are documented. A system is in place to monitor that risk assessments are done/updated as prescribed. Non-compliance with documented requirements is managed in accordance with consistently-applied, transparent and documented disciplinary procedures.";
      case 4:
        return "The safety and security risk assessment is regularly reviewed and improved by the management board with regards to: – how it compares with peers – its adequacy for the organisation (activities, means) Feedback from risk assessment is systematically obtained and used for impovement of induction";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getPreDepartureDebriefingText = (value) => {
    switch (value) {
      case 0:
        return "Briefings are received upon request.";
      case 1:
        return "Pre-departure briefings are documented in policies and security plans, and reflect the risk level of the location or role. A standard briefing template is provided. ";
      case 2:
        return "All travelling staff receive pre-departure briefings by the designated person in accordance with the risk level of the location and role. This information includes: – safety and security risks (including personal risks due to profile) – safety and security risk treatment measures – staff safety and security roles and responsibilities (procedures to follow) – staff right to withdraw (informed consent)";
      case 3:
        return "The provision of the briefing to travelling staff is registered, e.g. by staff acknowledging understanding of the content of the briefing in writing. Failure to obtain briefings in accordance with agreed-upon procedures is responded to in accordance with consistently-applied, documented and transparent disciplinary procedures.";
      case 4:
        return "Information in briefings is regularly updated using information received from: – peer learning/community of practice – risk assessments – post-deployment de-briefings – expert reviews Feedback from pre-departure briefings is systematically obtained and fed back to the induction process.";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getRiskTreatmentText = (value) => {
    switch (value) {
      case 0:
        return "Safety and security risk treatment is carried out in response to incidents rather than on the basis of proactive risk assessments.";
      case 1:
        return "Safety and security risk treatment measures are identified and documented in policy and plans.";
      case 2:
        return "Organisational risk threshold is identified. Safety and security risk treatment measures are systematically implemented based on the security risk assessment, including: – prevention – mitigation – equipment – training, etc. ";
      case 3:
        return "Implementation of safety and security risk treatment measures is documented and monitored against an agreed organisational risk threshold (as documented in policy). Non-compliance is responded to via consistently-applied, documented and transparent disciplinary procedures";
      case 4:
        return "The effectiveness of safety and security risk treatment measures is regularly reviewed and improved. Through learnings from: – internal and external incidents – other organisational processes (e.g., risk assessments) – staff feedback – expert review – peer learning/community of practice";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getPreDepartureMeasureText = (value) => {
    switch (value) {
      case 0:
        return "There is no consistency in whether travellers receive medical (physical and mental) support before travel or not. ";
      case 1:
        return "Pre-departure measures are identified and documented based on risk assessment for destination and role. All staff are informed.";
      case 2:
        return "Prior to departure travelling staff confirm to the designated person they implemented pre-depature measures. These measures include: – health checks (mental and physical) – vaccinations – medication – personal safety and security competence – country risk-specific information";
      case 3:
        return "Completion of pre-departure measures is documented and registered. Failure to complete all pre-departure measures is addressed in accordance with consistentlyapplied, documented and transparent disciplinary procedures.";
      case 4:
        return "Improvement is achieved through learnings from reviews, which include: – post-deployment de-briefings – other organisational processes (e.g., risk assessments) – peer learning – expert review";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getInusringAgainstText = (value) => {
    switch (value) {
      case 0:
        return "The organisation does not have comprehensive insurance coverage in place.";
      case 1:
        return "Required personal insurance coverage is identified and documented based on risk assessment of locations and roles. Required organisational insurance coverage is identified and documented based on risk assessment of locations and roles. ";
      case 2:
        return "Systematic procedures are in place to ensure that all staff are insured against: – health risks (as required) – liability risks (as required) The management takes systematic decisions on organisational insurance coverage based on identified risks.";
      case 3:
        return "Insurance coverage is monitored by experts. Provision of insurance information to staff is registered. Failure to obtain insurance coverage as prescribed in policy and plans is responded to in accordance with consistently-applied, documented and transparent disciplinary procedures. (under- and overcoverage to be checked)";
      case 4:
        return "Insurance policies and providers are assessed. Improvement is achieved through learnings from: – internal and external incidents – risk assessements – staff consultation – expert reviews – peer learning /community of practice";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getAuditingText = (value) => {
    switch (value) {
      case 0:
        return "The auditing of safety and security risk management in the organisation is ad hoc, reactive and not according to organisation-wide indicators.";
      case 1:
        return "Safety and security risk management auditing is documented.";
      case 2:
        return "The safety and security risk management system is regularly, systematically and consistently audited with regards to: – risk assessment – risk treatment – risk monitoring";
      case 3:
        return "Auditing is documented and carried out according to agreed-upon metrics. Key staff oversee the completion of the audit’s final improvement action plan. Failure to do so is addressed in accordance with consistently-applied, documented and transparent disciplinary procedures.";
      case 4:
        return "Staff is informed about the outcome of audits. Improvement is achieved through feedback and learnings from audit outcomes, which include: – comparision of audit results with peers and staff – internal and external incidents – risk assessments";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getSafetyAndSecurityText = (value) => {
    switch (value) {
      case 0:
        return "Safety and security incident data is captured in an inconsistent manner.";
      case 1:
        return "Safety and security incident data are documented in a standardised way.";
      case 2:
        return "Safety and security incident data is systematically: – gathered – processed – analyzed to support the incident response management process, risk assessment and risk treatment including crisis management. Outputs are systematically fed back into local, national, regional /international level organisational learning and decision-making, e.g.: – programming and reporting – safety and security procedures – advocacy/media response – HR – finance Designated staff are systematically trained in gathering, processing and analyzing incident information.";
      case 3:
        return "Safety and security incident information management is monitored and documented. Failure to do so is addressed in accordance with consistently-applied, documented and transparent disciplinary procedures. Underreporting of incidents is addressed through traget-oriented measures, which include: – awareness-raising – training ";
      case 4:
        return "Improvement is achieved through feedback and learnings about information management based on: – quality and quantity of internal and external incident reporting – peer learning/community of practice – staff consultation and feedback on trainings in information management – expert reviews Learnings from incident reporting databases are regularly shared across departments and within management, where deemed appropriate.";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getDocumentationText = (value) => {
    switch (value) {
      case 0:
        return "There is no consistent documentation of safety and security risk -related information";
      case 1:
        return "Safety and security risk management related information is documented.";
      case 2:
        return "Decisions and actions taken in relation to safety and security risk management are systematically documented at organizational level. These include: – policies – plans – procedures – staff signature documenting informed consent processes and understanding staff conduct requirements outlined by policy. Documents related to safety and security risk management are systematically archived.";
      case 3:
        return "Documentation processes is monitored. Non-compliance with documented requirements is managed in accordance with consistentlyapplied, transparent and documented disciplinary procedures.";
      case 4:
        return "Documentation is regularly reviewed and amended. Improvement is achieved through learnings from: – quality and quantity of internal and external documentation – peer learning/community of practice – staff consultation and feedback on documentation – expert reviews";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getCrisisManagementText = (value) => {
    switch (value) {
      case 0:
        return "Management response to crises is ad hoc and reactive.";
      case 1:
        return "Crisis response manuals / tools are elaborated in a) guidelines b) policies and c) approved plan that delineate a crisis management response structure. ";
      case 2:
        return "Response procedures responding and managing crises (internal and external) are documented and in accordance with prescribed risk levels. This process is supported by: – regular crisis management training – pre-identified and vetted crisis assistance providers – investigation procedures – identification of qualified crisis management staff – consideration of staff needs, e.g. staff with disabilities";
      case 3:
        return "Monitoring of the crisis management process implementation and preparation through: – registering crisis management training attendance – documentation and review of crisis management decision-making Non-compliance with documented requirements is managed in accordance with consistently-applied, transparent and documented disciplinary procedures.";
      case 4:
        return "Improvement is achieved through learning from crisis management experiences: – staff consultation – a lessons learned exercise – peer learning – other organisational processes (e.g., risk treatment) – a review of crisis response providers A process is in place to regularly test the crisis response management structure, through: – peer learning/community of practice – risk assessments – post-deployment de-briefings – expert reviews Feedback from crisis management responses is systematically fed back to the crisis management process.";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getPostDeploymentText = (value) => {
    switch (value) {
      case 0:
        return "Post-deployment/travel de-briefings are ad hoc and at the discretion of line managers";
      case 1:
        return "Post-deployment/travel de-briefings are regular. Timing is adequate, response structures defined and availabe.";
      case 2:
        return "Post-deployment/travel de-briefings are systematically integrated into related management processes and undertaken in accordance with prescribed risk levels through: – trip reports – face-to-face de-briefings with management and experts – provision of psycho-social support services And may be applicable for in-country and/or international travel in accordance with prescribed risk levels.";
      case 3:
        return "Monitor post-deployment/travel de-briefings: – Registering attendance at face-to-face de-briefings. Non-compliance with documented requirements is managed in accordance with consistently-applied, transparent and documented disciplinary procedures";
      case 4:
        return "Improvement is achieved through learning from post-deployment experiences: – staff consultation – a lessons learned exercise – peer learning – other organisational processes Feedback from post-deployment is systematically fed back to the postdeployment process.";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getComplaintMechanismText = (value) => {
    switch (value) {
      case 0:
        return "The receipt of complaints is ad hoc and linked to awareness-raising activities. Responses to complaints is reactive and unstructured and dependent on management interest and capacity.";
      case 1:
        return "Mechanism for receiving and addressing complaints is communicated and documented. ";
      case 2:
        return "Procedures for compaints and respond from internal and external individuals are communicated, systematic and transparent. It requires communication about and assurance that: – Anonymous reporting is guaranted and accessible through a variety of reporting mechanisms, e.g. online platform, email, letterbox. – Reponse is available in operational languages. This process is integrated into related management processes, including awareness raising activities within and outside of the organisation (e.g. training, induction, etc.). There is a process in place to protect the identity and well-being of reporters.";
      case 3:
        return "Monitoring complaints/response mechanism in accordance with agreed-upon metrics. Have anonymised report list of complaints. Documenting of the security audit process or relevant staff performance reviews. Non-compliance with documented requirements is managed in accordance with consistently-applied, transparent and documented disciplinary procedures.";
      case 4:
        return "The complaint procedures as well as response to complaints are systematically reviewed, for example, through a regular audit by experts. A process is in place to gather feedback on the complaints mechanism and amend processes accordingly. – internal and external incidents – other organisational processes (e.g., risk assessments) – staff consultation – peer learning/community of practice. Feedback from reviews are systematically fed back operational management and code of conduct.";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getDisiciplinaryText = (value) => {
    switch (value) {
      case 0:
        return "The organisation becomes aware of infringements on a staff members‘ physical and mental wellbeing in an informal way or by chance. Perpetrators of such infringements are randomly held accountable, with some not held to account at all.";
      case 1:
        return "A disciplinary/sanctions process is documented in policy and plans. This includes: – Documenting managers‘ responsibility and right to take action to discipline or sanction staff for lack of compliance.";
      case 2:
        return "Disciplinary procedures are in place that are consistently and transparently applied for non-compliance with documented requirements. This process includes: – Staff and managers to have formal opportunities to discuss infringements against the physical and mental wellbeing of staff, e.g. in the annual appraisal process or through a whistleblowing mechanism. – Managers to know when and how to escalate reports on infringements to another level (both internally or externally). – Managers to be trained on how to investigate reports and how to discipline or sanction at their level. – Supervising managers to take action when lower level managers fail to act in accordance with provisions. It is ensured that staff who report suspected non-compliance are not dicriminated against.";
      case 3:
        return "The organisation collects and analyses data on allegations of infringements against the physical and mental wellbeing of staff. This includes how reported cases were handled by management.";
      case 4:
        return "The disciplinary/sanctions policy and procedures are reglularly reviewed and amended. Such revision can be informed by, for example: – a dedicated internal lessons learned exercise – external expert review – risk assessments followin internal or external incidents – staff consultation – peer learning/community of practice Staff and managers’ awareness of their rights and obligations in relation to compliance is regularly assessed and improved, including procedures for investigating allegations of infringements.";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getHealthAndSafetyText = (value) => {
    switch (value) {
      case 0:
        return "There is no consistent process for meeting site-related health and safety regulations.";
      case 1:
        return "Health and safety regulations to meet reasonable standards in all the organisation’s facilities, including offices, accommodation and warehouses are documented. Staff care support is available and documented in policy or regulations in all countries in the form of services (internal or external) and/or trainings.";
      case 2:
        return "Responsibilities for the implementation of health and safety regulations in all the organisation’s facilities are clearly defined and reflected in job-descriptions. Site-related health and safety considerations are integral part of relevant management processes, e.g. project management, budgeting. Risk management is integrated into related management processes, e.g. risk assessments. Staff care measures are put in place and are adequate. Staff’s wellbeing is systematically assessed and acted upon at the end of deployments or after serious incidents. Staff are encouraged to attend sessions or access services in a confidential manner and can do so without going through their line manager or other senior staff";
      case 3:
        return "Site health and safety measures are systematically audited according to transparent criteria. Staff’s wellbeing is benchmarked against acknowledged criteria, e.g. through regluar reports from the responsible for staff care or by means of a staff barometer. Adjustments are made on the basis of monitoring outcomes and infringements addressed in accordance with policy";
      case 4:
        return "The health and safety process is regularly reviewed, and learnings used to adapt the process for continuous improvement. This can be informed by, for example: – analysis of incidents (internal or external) – staff consultation – expert review – peer learning/community of practice – legislative changes";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getRedressMeasureText = (value) => {
    switch (value) {
      case 0:
        return "Staff access to redress measures is ad hoc and dependent on senior management interest.";
      case 1:
        return "Redress measures are documented in policy or regulations allowing staff (or their next of kin) to ask for satisfaction of un-covered needs.";
      case 2:
        return "Management at the appropriate level receive information on un-covered needs of staff (or their next of kin) having suffered a wrong at their workplace. Such needs may be e.g.: – additional psychological support to staff or their next of kin – financial losses to staff or their next of kin – flexible return to work options – legal or administrative support The information is formally acted upon and the decision shared to the staff concerned (or their next of kin). The organisation has the resources at hand to provide redress measures, e.g. a special fund for extraordinary measures.";
      case 3:
        return "The concerned staff (or their next of kin) have the possibility to appeal decisions taken in respect to redress measures concerning them";
      case 4:
        return "Learnings concerning systemically un-covered needs after critical incidents are gathered, for example, through information from, e.g.: – de-briefings with affected staff about the incident – wider staff consultation – expert review – peer learning/community of practice – regular reporting from the responsible for staff care The coverage of needs arising from critical incidents is periodically reviewed and improved where feasible.";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getRiskManagmentText = (value) => {
    switch (value) {
      case 0:
        return "Safety and security risk management roles and responsibilities are not well-informed and designated reactively.";
      case 1:
        return "The safety and security risk management process is documented in policy or guidelines. The persons responsible for safety and security are identified and communicated.";
      case 2:
        return "Safety and security risk management is integrated into relevant other management processes, for example, HR processes, project management, finance management, compliance, etc. Risk owners and risk managers are defined and their responsiblities and tasks reflected in job-descriptions. Expertise is sought where needed to duly inform safety and security risk management steps (assessment, treatment, monitoring, communicating). This includes expertise on crisis management.";
      case 3:
        return "Safety and security risk management is periodically audited based on reckognised standards. Job descriptions are regularly checked against actual tasks and requirements.";
      case 4:
        return "Safety and security risk management processes and roles are regularly reviewed and updated in accordance with learnings from, e.g.: – staff consultation – expert review – peer learning/community of practice";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  const getPartnerShipArrangementText = (value) => {
    switch (value) {
      case 0:
        return "Partnership arrangements are driven by programmatic and strategic demands and do not consider safety and security considerations.";
      case 1:
        return "The way how safety and security risks are managed in partnership arrangements is documented in policy or regulations. This includes: – the way to attribute roles and responsibilities of the partners in relation to safety and security – the way to attribute roles and responsibilities of the partners in relation to crisis management";
      case 2:
        return "Due diligence checks on partner organisations are carried out systematically before entering into partnership agreements, this includes: – the partner’s capacity to take care of their employees – the partner’s capacity to manage crisis Written partnership arrangements specify the partners’ roles and reponsibilities in relation to: – safety and security – crisis management – capacity building (where deemed appropriate) This applies in particular to consortia arrangements and to seconded staff.";
      case 3:
        return "Partnership arrangements are periodically checked for completeness in relation to: – due diligence done – contractual specifications Failure to comply with this process is brought to the attention of senior management and remedial measures are taken.";
      case 4:
        return "Due diligence processes and partnership arrangements are regularly reviewed and assessed. Learnings are acted upon and informed by, e.g.: – analysis of incidents (internal or external) – staff consultation – expert review – peer learning/community of practice";
      default:
        return "Maintain standards for the Optimised Level";
    }
  };

  return (
    <Card>
      <Card.Header>
        <Card.Title as="h5">
          <h4>Assessment Id: # {assesmentId} </h4>
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col xs={6} />
          <Col xs={6} style={{ textAlign: "right" }}>
            <Button onClick={exportPdf}>
              Download PDF{" "}
              {downloadingPDF && (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              )}
            </Button>{" "}
            &nbsp;
            <Button onClick={exportImage}>
              Download Image
              {downloadingPDFImage && (
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              )}
            </Button>
          </Col>
        </Row>
        <Row id="capture">
          <Col xl={12}>
            <img src={logo} alt="logo" />
          </Col>
          <Col
            xs={12}
            style={{
              marginTop: "20px",
            }}
          >
            <table className="w-full colored-table summary-table half-table">
              <tr>
                <td>Assessors First and Last Name</td>
                <td>{assesmentDetails?.assesorFirstName?.value}</td>
              </tr>
              <tr>
                <td>Assessors Phone Number</td>
                <td>{assesmentDetails?.assesorPhoneNumber?.value}</td>
              </tr>
              <tr>
                <td>Assessors Email</td>
                <td>{assesmentDetails?.assesorEmail?.value}</td>
              </tr>
              <tr>
                <td>Co-Assessors First and Last Name</td>
                <td>{assesmentDetails?.coAssessortFirstName?.value}</td>
              </tr>
              <tr>
                <td>Co-Assessors Phone Number</td>
                <td>{assesmentDetails?.coAssesorPhoneNumber?.value}</td>
              </tr>
              <tr>
                <td>Co-Assessors Email</td>
                <td>{assesmentDetails?.coAssesorEmail?.value}</td>
              </tr>
              <tr>
                <td>Agency Name</td>
                <td>
                  {assesmentDetails?.siteName?.value?.value ||
                    assesmentDetails?.siteName?.value ||
                    ""}
                </td>
              </tr>
              <tr>
                <td>Country </td>
                <td>
                  {assesmentDetails?.country?.value?.value ||
                    assesmentDetails?.country?.value ||
                    ""}
                </td>
              </tr>
              <tr>
                <td>Date of Assessment </td>
                <td>
                  {moment(assesmentDetails?.date?.value).format("DD/MM/YYYY")}
                </td>
              </tr>
            </table>
          </Col>
          <Col xl={12}>
            <div id="page">
              <main aria-label="Main Chart">
                <section id="radar" />
              </main>
            </div>
          </Col>
          <Col
            xl={6}
            style={{
              padding: "10px",
            }}
          >
            <div
              style={{
                borderBottom: "6px solid #66CCFF",
              }}
            >
              <h3>Duty of Information</h3>
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Recruitment</span>{" "}
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(radarResponse.dutyOfInformation.recruitment)}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Induction /Onboarding</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(
                    radarResponse.dutyOfInformation.induction_and_onboarding
                  )}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Training</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(radarResponse.dutyOfInformation.training)}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>RiskAssessment</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(radarResponse.dutyOfInformation.risk_assessment)}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Pre-departureBriefings</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(
                    radarResponse.dutyOfInformation.pre_departure_for_traveller
                  )}
                </span>
              </div>
            </div>
          </Col>
          <Col
            xl={6}
            style={{
              padding: "10px",
            }}
          >
            <div
              style={{
                borderBottom: "6px solid #CCCC22",
              }}
            >
              <h3>Duty of Prevention</h3>
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Risk Treatment</span>{" "}
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(radarResponse.duty_of_prevention.risk_treatment)}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Pre-departure Measure</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(
                    radarResponse.duty_of_prevention.pre_departure_measure
                  )}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Insuring against risk</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(
                    radarResponse.duty_of_prevention.insuring_against_risk
                  )}
                </span>
              </div>
            </div>
          </Col>
          <Col
            xl={6}
            style={{
              padding: "10px",
            }}
          >
            <div
              style={{
                borderBottom: "6px solid #FFA000",
              }}
            >
              <h3>Duty of Monitoring</h3>
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Auditing</span>{" "}
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(radarResponse.duty_of_monitoring.auditing)}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Information Management</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(
                    radarResponse.duty_of_monitoring.safety_and_security
                  )}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Documentation</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(radarResponse.duty_of_monitoring.documentation)}
                </span>
              </div>
            </div>
          </Col>
          <Col
            xl={6}
            style={{
              padding: "10px",
            }}
          >
            <div
              style={{
                borderBottom: "6px solid #AA5500",
              }}
            >
              <h3>Duty of Intervention</h3>
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Crisis Management</span>{" "}
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(
                    radarResponse.duty_of_intervention.crisis_management
                  )}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Travel De-briefing</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(radarResponse.duty_of_intervention.post_deployment)}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Complaints Mechanism</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(
                    radarResponse.duty_of_intervention.complaints_mechanism
                  )}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Disciplinary Procedures</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(
                    radarResponse.duty_of_intervention.disciplinary_procedures
                  )}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Health and Safety</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(
                    radarResponse.duty_of_intervention.health_and_safety
                  )}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Redress Measure</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(radarResponse.duty_of_intervention.redress_measure)}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Risk Management</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(radarResponse.duty_of_intervention.risk_management)}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "10px",
                }}
              >
                <span>Partnership Arrangements</span>
                <span
                  style={{
                    backgroundColor: "#BB0099",
                    color: "#fff",
                    padding: "5px 10px",
                    borderRadius: "10px",
                  }}
                >
                  {getText(
                    radarResponse.duty_of_intervention.partnership_arrangement
                  )}
                </span>
              </div>
            </div>
          </Col>

          <Col xl={12} className="mt-2 p-2">
            <table className="w-full p-2 data-table-assesment5 no-layout">
              <thead>
                <tr>
                  <td
                    className="border border-gray-300"
                    style={{
                      width: "10%",
                    }}
                  >
                    Duty
                  </td>
                  <td className="border border-gray-300">Category</td>
                  <td>Current Maturity Level</td>
                  <td>Steps to achieve Next maturity Level</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    rowSpan={5}
                    style={{
                      backgroundColor: "#66CCFF",
                      color: "#fff",
                    }}
                  >
                    Duty of Information
                  </td>
                  <td>Recruitment</td>
                  <td>
                    {getText(radarResponse.dutyOfInformation.recruitment)} :{" "}
                    {getRecuritmentText(
                      radarResponse.dutyOfInformation.recruitment
                    )}
                  </td>
                  <td>
                    {getText(radarResponse.dutyOfInformation.recruitment + 1)} :{" "}
                    {getRecuritmentText(
                      radarResponse.dutyOfInformation.recruitment + 1
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Induction and onboarding</td>
                  <td>
                    {getText(
                      radarResponse.dutyOfInformation.induction_and_onboarding
                    )}{" "}
                    :{" "}
                    {getInductionText(
                      radarResponse.dutyOfInformation.induction_and_onboarding
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.dutyOfInformation.induction_and_onboarding +
                        1
                    )}{" "}
                    :{" "}
                    {getInductionText(
                      radarResponse.dutyOfInformation.induction_and_onboarding +
                        1
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Training</td>
                  <td>
                    {getText(radarResponse.dutyOfInformation.training)} :{" "}
                    {getTrainingText(radarResponse.dutyOfInformation.training)}
                  </td>
                  <td>
                    {getText(radarResponse.dutyOfInformation.training + 1)} :{" "}
                    {getTrainingText(
                      radarResponse.dutyOfInformation.training + 1
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Risk Assesment</td>
                  <td>
                    {getText(radarResponse.dutyOfInformation.risk_assessment)} :{" "}
                    {getRiskAssessmentText(
                      radarResponse.dutyOfInformation.risk_assessment
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.dutyOfInformation.risk_assessment + 1
                    )}{" "}
                    :{" "}
                    {getRiskAssessmentText(
                      radarResponse.dutyOfInformation.risk_assessment + 1
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Pre-departure Briefings</td>
                  <td>
                    {getText(
                      radarResponse.dutyOfInformation
                        .pre_departure_for_traveller
                    )}{" "}
                    :{" "}
                    {getPreDepartureDebriefingText(
                      radarResponse.dutyOfInformation
                        .pre_departure_for_traveller
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.dutyOfInformation
                        .pre_departure_for_traveller + 1
                    )}{" "}
                    :{" "}
                    {getPreDepartureDebriefingText(
                      radarResponse.dutyOfInformation
                        .pre_departure_for_traveller + 1
                    )}
                  </td>
                </tr>
                <tr>
                  <td
                    rowSpan={3}
                    style={{
                      backgroundColor: "#CCCC22",
                      color: "#fff",
                    }}
                  >
                    Duty of Prevention
                  </td>
                  <td>Risk Treatment</td>
                  <td>
                    {getText(radarResponse.duty_of_prevention.risk_treatment)} :{" "}
                    {getRiskTreatmentText(
                      radarResponse.duty_of_prevention.risk_treatment
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_prevention.risk_treatment + 1
                    )}{" "}
                    :{" "}
                    {getRiskTreatmentText(
                      radarResponse.duty_of_prevention.risk_treatment + 1
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Pre-Departure Measure</td>
                  <td>
                    {getText(
                      radarResponse.duty_of_prevention.pre_departure_measure
                    )}{" "}
                    :{" "}
                    {getPreDepartureMeasureText(
                      radarResponse.duty_of_prevention.pre_departure_measure
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_prevention.pre_departure_measure + 1
                    )}{" "}
                    :{" "}
                    {getPreDepartureMeasureText(
                      radarResponse.duty_of_prevention.pre_departure_measure + 1
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Insuring against Risk</td>
                  <td>
                    {getText(
                      radarResponse.duty_of_prevention.insuring_against_risk
                    )}{" "}
                    :{" "}
                    {getInusringAgainstText(
                      radarResponse.duty_of_prevention.insuring_against_risk
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_prevention.insuring_against_risk + 1
                    )}{" "}
                    :{" "}
                    {getInusringAgainstText(
                      radarResponse.duty_of_prevention.insuring_against_risk + 1
                    )}
                  </td>
                </tr>
                <tr>
                  <td
                    rowSpan={3}
                    style={{
                      backgroundColor: "#FFA000",
                      color: "#fff",
                    }}
                  >
                    Duty of Monitoring
                  </td>
                  <td>Auditing</td>
                  <td>
                    {getText(radarResponse.duty_of_monitoring.auditing)} :{" "}
                    {getAuditingText(radarResponse.duty_of_monitoring.auditing)}
                  </td>
                  <td>
                    {getText(radarResponse.duty_of_monitoring.auditing + 1)} :{" "}
                    {getAuditingText(
                      radarResponse.duty_of_monitoring.auditing + 1
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Information Management</td>
                  <td>
                    {getText(
                      radarResponse.duty_of_monitoring.safety_and_security
                    )}{" "}
                    :{" "}
                    {getSafetyAndSecurityText(
                      radarResponse.duty_of_monitoring.safety_and_security
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_monitoring.safety_and_security + 1
                    )}{" "}
                    :{" "}
                    {getSafetyAndSecurityText(
                      radarResponse.duty_of_monitoring.safety_and_security + 1
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Documentation</td>
                  <td>
                    {getText(radarResponse.duty_of_monitoring.documentation)} :{" "}
                    {getDocumentationText(
                      radarResponse.duty_of_monitoring.documentation
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_monitoring.documentation + 1
                    )}{" "}
                    :{" "}
                    {getDocumentationText(
                      radarResponse.duty_of_monitoring.documentation + 1
                    )}
                  </td>
                </tr>
                <tr>
                  <td
                    rowSpan={8}
                    style={{
                      backgroundColor: "#AA5500",
                      color: "#fff",
                    }}
                  >
                    Duty of Intervention
                  </td>
                  <td>Crisis Management</td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.crisis_management
                    )}{" "}
                    :{" "}
                    {getCrisisManagementText(
                      radarResponse.duty_of_intervention.crisis_management
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.crisis_management + 1
                    )}{" "}
                    :{" "}
                    {getCrisisManagementText(
                      radarResponse.duty_of_intervention.crisis_management + 1
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Travel De briefing</td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.post_deployment
                    )}{" "}
                    :{" "}
                    {getPostDeploymentText(
                      radarResponse.duty_of_intervention.post_deployment
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.post_deployment + 1
                    )}{" "}
                    :{" "}
                    {getPostDeploymentText(
                      radarResponse.duty_of_intervention.post_deployment + 1
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Complaints Mechanism</td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.complaints_mechanism
                    )}{" "}
                    :{" "}
                    {getComplaintMechanismText(
                      radarResponse.duty_of_intervention.complaints_mechanism
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.complaints_mechanism +
                        1
                    )}{" "}
                    :{" "}
                    {getComplaintMechanismText(
                      radarResponse.duty_of_intervention.complaints_mechanism +
                        1
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Disciplinary Procedures</td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.disciplinary_procedures
                    )}{" "}
                    :{" "}
                    {getDisiciplinaryText(
                      radarResponse.duty_of_intervention.disciplinary_procedures
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention
                        .disciplinary_procedures + 1
                    )}{" "}
                    :{" "}
                    {getDisiciplinaryText(
                      radarResponse.duty_of_intervention
                        .disciplinary_procedures + 1
                    )}
                  </td>
                </tr>{" "}
                <tr>
                  <td>Health and Safety</td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.health_and_safety
                    )}{" "}
                    :{" "}
                    {getHealthAndSafetyText(
                      radarResponse.duty_of_intervention.health_and_safety
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.health_and_safety + 1
                    )}{" "}
                    :{" "}
                    {getHealthAndSafetyText(
                      radarResponse.duty_of_intervention.health_and_safety + 1
                    )}
                  </td>
                </tr>{" "}
                <tr>
                  <td>Redress Measure</td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.redress_measure
                    )}{" "}
                    :{" "}
                    {getRedressMeasureText(
                      radarResponse.duty_of_intervention.redress_measure
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.redress_measure + 1
                    )}{" "}
                    :{" "}
                    {getRedressMeasureText(
                      radarResponse.duty_of_intervention.redress_measure + 1
                    )}
                  </td>
                </tr>{" "}
                <tr>
                  <td>Risk Management</td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.risk_management
                    )}{" "}
                    :{" "}
                    {getRiskManagmentText(
                      radarResponse.duty_of_intervention.risk_management
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.risk_management + 1
                    )}{" "}
                    :{" "}
                    {getRiskManagmentText(
                      radarResponse.duty_of_intervention.risk_management + 1
                    )}
                  </td>
                </tr>{" "}
                <tr>
                  <td>Partnership Arrangements</td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention.partnership_arrangement
                    )}{" "}
                    :{" "}
                    {getPartnerShipArrangementText(
                      radarResponse.duty_of_intervention.partnership_arrangement
                    )}
                  </td>
                  <td>
                    {getText(
                      radarResponse.duty_of_intervention
                        .partnership_arrangement + 1
                    )}{" "}
                    :{" "}
                    {getPartnerShipArrangementText(
                      radarResponse.duty_of_intervention
                        .partnership_arrangement + 1
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </Col>
          <Col
            span={12}
            style={{
              margin: "20px",
            }}
          >
            This product is based on a Duty of Care Maturity Model produced by
            the Swiss Centre of Competence for International Cooperation
            (CINFO). For more information please visit 
            <a href="https://www.cinfo.ch/en">https://www.cinfo.ch/en</a>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
}

export default Assesment5Summary;
